module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    key: _vm.key,
    ref: _vm.componentId,
    on: {
      "input": _vm.closeInput
    }
  }, [(_vm.couponProp) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]) : _c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Activation code"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.code),
      expression: "body.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "code", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Valid from"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "initial-date": _vm.body.start,
      "format": "yyyy-mm-dd hh:ii:ss"
    },
    model: {
      value: (_vm.body.start),
      callback: function($$v) {
        _vm.$set(_vm.body, "start", $$v)
      },
      expression: "body.start"
    }
  })], 1), _c('label', [_vm._v("Valid to"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "initial-date": _vm.body.end,
      "format": "yyyy-mm-dd hh:ii:ss"
    },
    model: {
      value: (_vm.body.end),
      callback: function($$v) {
        _vm.$set(_vm.body, "end", $$v)
      },
      expression: "body.end"
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Type"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Fixed")]), _c('option', [_vm._v("Percentage")])])]), (_vm.type == 'Fixed') ? [_c('label', [_vm._v("Common Cost"), _c('selectize-common-cost', {
    attrs: {
      "selectedValue": _vm.body.common_cost_id
    },
    on: {
      "optionSelected": _vm.setCommonCost
    }
  })], 1), _c('label', [_vm._v("Service"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.service),
      expression: "body.service"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _c('option', [_vm._v("Reservation")]), _c('option', [_vm._v("Subscription")])])])] : [_c('label', [_vm._v("Discount percentage"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.discount_rate),
      expression: "body.discount_rate"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.body.discount_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "discount_rate", $event.target.value)
      }
    }
  })])], (_vm.type == 'Fixed') ? [_c('label', [_vm._v("Exipiry date"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "initial-date": _vm.body.expiry_date,
      "format": "yyyy-mm-dd hh:ii:ss"
    },
    model: {
      value: (_vm.body.expiry_date),
      callback: function($$v) {
        _vm.$set(_vm.body, "expiry_date", $$v)
      },
      expression: "body.expiry_date"
    }
  })], 1), _c('label', [_vm._v("Max days"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.max_days),
      expression: "body.max_days"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.body.max_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "max_days", $event.target.value)
      }
    }
  })])] : _vm._e(), _c('label', [_vm._v("Max uses"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.max_uses),
      expression: "body.max_uses"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.body.max_uses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "max_uses", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Max uses per driver"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.max_uses_per_driver),
      expression: "body.max_uses_per_driver"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.body.max_uses_per_driver)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "max_uses_per_driver", $event.target.value)
      }
    }
  })])], 2)]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4062fea0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CouponReveal.vue
// module id = 2427
// module chunks = 1